var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-4749.634 5772 31.17 18.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8b31e;\n      }\n\n      .cls-2 {\n        fill: #e2051f;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 0.215px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(-4749.634 5772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-2",
    "data-name": "group",
    transform: "translate(12.513 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    className: "cls-1",
    d: "M-42.459,0l-.478.013-.475.035-.466.06-.46.082-.45.1-.444.126-.431.148-.425.167L-46.5.922l-.4.2-.39.224-.378.242-.365.261-.353.277-.336.292-.324.309-.308.324-.293.34-.277.349-.258.365-.242.381-.224.387-.208.4-.186.412-.167.422-.145.434-.126.44-.1.45-.082.456-.06.465-.035.472-.013.479.013.481.035.475.06.465.082.463.1.45.126.444.145.435.167.425.186.415.208.4.224.39.242.381.258.365.277.352.293.34.308.324.324.311.336.293.353.277.365.261.378.242.39.226.4.2.412.189.425.167.431.148.444.126.45.1.46.082.466.06.475.035.478.013.482-.013.475-.035.466-.06.463-.082.45-.1.444-.126.434-.148.425-.167.415-.189.4-.2.39-.226.381-.242.365-.261.352-.277.34-.293.324-.311.311-.324.293-.34.277-.352.261-.365.242-.381.226-.39.2-.4.189-.415.167-.425.148-.435.126-.444.1-.45.082-.463.06-.465.034-.475.013-.481-.013-.479-.034-.472-.06-.465-.082-.456-.1-.45-.126-.44-.148-.434-.167-.422-.189-.412-.2-.4-.226-.387-.242-.381-.261-.365-.277-.349-.293-.34-.311-.324-.324-.309-.34-.292-.352-.277-.365-.261-.381-.242L-38,1.126l-.4-.2-.415-.189-.425-.167-.434-.148-.444-.126-.45-.1-.463-.082L-41.5.047l-.475-.035Z",
    transform: "translate(51.77 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-3",
    "data-name": "group",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    className: "cls-2",
    d: "M-42.617,0-43.1.013l-.475.035-.466.06L-44.5.189l-.45.1-.444.126-.434.148-.425.167-.415.189-.4.2-.39.224-.381.242-.365.261-.352.277-.34.292-.324.309-.311.324-.293.34-.277.349-.261.365-.242.381-.227.387-.2.4-.189.412-.167.422-.148.434-.126.44-.1.45-.082.456-.06.465-.034.472-.013.479.013.481.034.475.06.465.082.463.1.45.126.444.148.435.167.425.189.415.2.4.227.39.242.381.261.365.277.352.293.34.311.324.324.311.34.293.352.277.365.261.381.242.39.226.4.2.415.189.425.167.434.148.444.126.45.1.463.082.466.06.475.035.481.013.478-.013.475-.035.466-.06.459-.082.45-.1.444-.126.431-.148.425-.167.412-.189.4-.2.39-.226.378-.242.365-.261.353-.277.336-.293.324-.311.308-.324.292-.34.277-.352.258-.365.242-.381.224-.39.207-.4.186-.415.167-.425.145-.435.126-.444.1-.45.082-.463.06-.465.035-.475.013-.481-.013-.479-.035-.472-.06-.465-.082-.456-.1-.45-.126-.44-.145-.434-.167-.422-.186-.412-.207-.4-.224-.387-.242-.381-.258-.365L-35.43,3.4l-.292-.34-.308-.324-.324-.309-.336-.292-.353-.277-.365-.261-.378-.242-.39-.224-.4-.2-.412-.189-.425-.167-.431-.148-.444-.126-.45-.1L-41.2.107l-.466-.06-.475-.035Z",
    transform: "translate(51.962 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-4",
    "data-name": "group",
    transform: "translate(14.493 3.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    className: "cls-1",
    d: "M0-2.31H4.956v-.506H.428Z",
    transform: "translate(0 2.816)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-5",
    "data-name": "group",
    transform: "translate(13.75 4.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    "data-name": "path",
    className: "cls-1",
    d: "M0-2.31H5.7v-.506H.3Z",
    transform: "translate(0 2.816)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-6",
    "data-name": "group",
    transform: "translate(13.196 5.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    "data-name": "path",
    className: "cls-1",
    d: "M0-2.31H6.252v-.506H.22Z",
    transform: "translate(0 2.816)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-7",
    "data-name": "group",
    transform: "translate(12.816 6.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-6",
    "data-name": "path",
    className: "cls-1",
    d: "M0-2.31H6.633v-.507H.157Z",
    transform: "translate(0 2.817)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-8",
    "data-name": "group",
    transform: "translate(12.879 11.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    "data-name": "path",
    className: "cls-1",
    d: "M-.718-2.31H5.711v-.506H-.875Z",
    transform: "translate(0.875 2.816)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-9",
    "data-name": "group",
    transform: "translate(13.275 13.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-8",
    "data-name": "path",
    className: "cls-1",
    d: "M-1.076-2.31H4.877v-.507H-1.312Z",
    transform: "translate(1.312 2.817)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-10",
    "data-name": "group",
    transform: "translate(13.86 14.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-9",
    "data-name": "path",
    className: "cls-1",
    d: "M-1.449-2.31H3.837v-.507h-5.6Z",
    transform: "translate(1.767 2.817)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-11",
    "data-name": "group",
    transform: "translate(14.653 15.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-10",
    "data-name": "path",
    className: "cls-1",
    d: "M-2.023-2.324H2.344v-.51H-2.467Z",
    transform: "translate(2.467 2.834)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-12",
    "data-name": "group",
    transform: "translate(12.592 7.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-11",
    "data-name": "path",
    className: "cls-1",
    d: "M0-2.31H6.856v-.506H.1Z",
    transform: "translate(0 2.816)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-13",
    "data-name": "group",
    transform: "translate(16.771 10.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-12",
    "data-name": "path",
    className: "cls-1",
    d: "M0-2.31H2.615v-.506H.094Z",
    transform: "translate(0 2.816)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-14",
    "data-name": "group",
    transform: "translate(16.979 9.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-13",
    "data-name": "path",
    className: "cls-1",
    d: "M0-2.324H2.407v-.51H.094Z",
    transform: "translate(0 2.834)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-15",
    "data-name": "group",
    transform: "translate(12.419 9.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-14",
    "data-name": "path",
    className: "cls-1",
    d: "M0,0H.68V.51H.031Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-16",
    "data-name": "group",
    transform: "translate(8.508 8.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-15",
    "data-name": "path",
    className: "cls-3",
    d: "M-12.053-3.615l-.044,0-.044-.006-.041-.006-.041-.006-.038-.006L-12.3-3.65l-.041-.006-.044-.006-.044-.006-.05,0-.057,0-.06,0h-.066l-.072,0-.082.006-.091.006-.063.009-.06.01-.053.019-.047.019-.044.022-.041.025-.031.031-.028.028-.019.035-.016.035-.006.038v.038l.009.041.013.041.025.041.031.041.063.06.076.047.088.041.094.035.1.031.1.035.1.038.1.041.094.053.088.066.079.079.066.1.05.12.031.142.013.17-.013.2-.022.148-.038.129-.05.119-.063.1-.072.091-.082.079-.088.069-.1.06-.1.047-.1.041-.107.031-.11.025-.107.019-.1.009-.1.006-.1,0h-.135l-.126,0h-.11l-.1,0-.094,0L-14.1-.972l-.076-.006-.072-.01-.066-.006-.06-.013-.06-.01-.054-.016-.053-.012-.05-.019-.05-.019L-14.7-1.1l.142-.7.028.006.035.01.044.013.053.012.057.013.063.013.069.016.076.013.079.012.082.013.085.01.088.01.091,0,.091,0h.091l.091,0,.091-.019.072-.025.057-.035.044-.044.031-.044.025-.05.016-.05.013-.047.006-.091-.028-.079-.053-.063-.079-.053L-13.33-2.3l-.11-.047-.123-.044-.123-.05-.126-.057-.12-.066-.11-.082-.1-.1-.079-.12-.056-.142-.028-.17,0-.2.016-.123.022-.117.031-.107.038-.1.05-.094L-14.089-4l.066-.079.079-.069.091-.06.1-.05.113-.047.126-.035.142-.028.154-.022.17-.013.186,0h.116l.107,0,.1,0,.088,0,.079.006.072.006.063.006.057.006.053.006.044.01.041.006.038.006.031.006.028,0,.028.006.025,0Z",
    transform: "translate(14.696 4.408)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-17",
    "data-name": "group",
    transform: "translate(8.508 8.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-16",
    "data-name": "path",
    className: "cls-4",
    d: "M-12.053-3.615h0l-.044,0-.044-.006-.041-.006-.041-.006-.038-.006L-12.3-3.65l-.041-.006-.044-.006-.044-.006-.05,0-.057,0-.06,0h-.066l-.072,0-.082.006-.091.006-.063.009-.06.01-.053.019-.047.019-.044.022-.041.025-.031.031-.028.028-.019.035-.016.035-.006.038v.038l.009.041.013.041.025.041.031.041.063.06.076.047.088.041.094.035.1.031.1.035.1.038.1.041.094.053.088.066.079.079.066.1.05.12.031.142.013.17-.013.2-.022.148-.038.129-.05.119-.063.1-.072.091-.082.079-.088.069-.1.06-.1.047-.1.041-.107.031-.11.025-.107.019-.1.009-.1.006-.1,0h-.135l-.126,0h-.11l-.1,0-.094,0L-14.1-.972l-.076-.006-.072-.01-.066-.006-.06-.013-.06-.01-.054-.016-.053-.012-.05-.019-.05-.019L-14.7-1.1l.142-.7.028.006.035.01.044.013.053.012.057.013.063.013.069.016.076.013.079.012.082.013.085.01.088.01.091,0,.091,0h.091l.091,0,.091-.019.072-.025.057-.035.044-.044.031-.044.025-.05.016-.05.013-.047.006-.091-.028-.079-.053-.063-.079-.053L-13.33-2.3l-.11-.047-.123-.044-.123-.05-.126-.057-.12-.066-.11-.082-.1-.1-.079-.12-.056-.142-.028-.17,0-.2.016-.123.022-.117.031-.107.038-.1.05-.094L-14.089-4l.066-.079.079-.069.091-.06.1-.05.113-.047.126-.035.142-.028.154-.022.17-.013.186,0h.116l.107,0,.1,0,.088,0,.079.006.072.006.063.006.057.006.053.006.044.01.041.006.038.006.031.006.028,0,.028.006.025,0-.16.711",
    transform: "translate(14.696 4.408)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-18",
    "data-name": "group",
    transform: "translate(11.277 7.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-17",
    "data-name": "path",
    className: "cls-3",
    d: "M-2.827,0h.872l-.129.761h.526l-.113.711-.554-.016-.3,1.756,0,.063.016.054.031.041.041.035.056.022.063.019.069.013.076.006.069,0,.063-.006.057-.01.05-.013L-1.9,3.42l.028-.009.019-.006.006,0-.11.585L-1.977,4-2,4.015l-.022.013-.022.013-.022.01-.025.009-.028.009-.028.01-.031.009-.031.006-.038.006-.038.006-.041.006-.047.006-.05.006-.054.006h-.239l-.126-.009-.11-.013-.1-.019-.085-.022-.072-.028-.06-.031-.053-.038-.041-.041L-3.4,3.886l-.022-.053-.016-.053-.01-.06,0-.066V3.584l.01-.072.009-.079Z",
    transform: "translate(3.447)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-19",
    "data-name": "group",
    transform: "translate(11.277 7.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-18",
    "data-name": "path",
    className: "cls-4",
    d: "M-2.827,0h.872l-.129.761h.526l-.113.711-.554-.016-.3,1.756,0,.063.016.054.031.041.041.035.056.022.063.019.069.013.076.006.069,0,.063-.006.057-.01.05-.013L-1.9,3.42l.028-.009.019-.006.006,0-.11.585L-1.977,4-2,4.015l-.022.013-.022.013-.022.01-.025.009-.028.009-.028.01-.031.009-.031.006-.038.006-.038.006-.041.006-.047.006-.05.006-.054.006h-.239l-.126-.009-.11-.013-.1-.019-.085-.022-.072-.028-.06-.031-.053-.038-.041-.041L-3.4,3.886l-.022-.053-.016-.053-.01-.06,0-.066V3.584l.01-.072.009-.079L-2.827,0",
    transform: "translate(3.447)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-20",
    "data-name": "group",
    transform: "translate(12.941 8.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-19",
    "data-name": "path",
    className: "cls-3",
    d: "M-4.19-8.954-4.2-8.9l0,.056.006.06.013.06.022.06.025.057.035.06.038.054.044.053.047.047.05.047.057.038.057.035.063.028.063.022.063.013.082.012.079.01.082.01.082.006.082,0h.085l.082,0,.085-.006.085-.013.085-.016.088-.019.085-.028.088-.035.091-.038.088-.05.091-.053-.126.774-.05.025-.05.025-.05.019-.047.019-.047.016-.05.016-.05.012-.054.01-.057.01-.063.006-.066.006-.072.006-.082,0h-.085l-.1,0h-.1l-.154,0L-3.725-7.5l-.157-.022-.157-.038-.154-.047-.148-.06-.142-.079-.132-.091-.123-.107-.107-.129-.091-.145-.076-.167-.054-.186L-5.1-8.781l-.01-.233.016-.258.013-.1.019-.117.025-.122L-5-9.743l.047-.135.056-.135.072-.138.088-.132.1-.126.123-.12.138-.107.157-.095.183-.078.2-.057L-3.6-10.9l.255-.012.123,0,.129.012.129.022.129.032.126.047.123.057.113.076.1.088.094.107.079.126.063.145.044.167.025.189,0,.214-.022.239-.047.265-.016.192H-4.445l.145-.62h1.378l.006-.079,0-.076-.006-.069-.013-.063L-2.96-9.9l-.022-.053L-3.013-10l-.031-.044-.038-.038-.041-.031-.047-.028-.047-.025-.05-.019-.05-.013-.053-.009-.057-.006-.06,0-.057.009-.053.013-.053.019-.054.025-.047.028-.047.035-.041.038L-3.882-10l-.038.047-.035.05-.028.054-.028.057-.022.063-.019.063-.013.066Z",
    transform: "translate(5.109 10.917)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-21",
    "data-name": "group",
    transform: "translate(12.941 8.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-20",
    "data-name": "path",
    className: "cls-4",
    d: "M-4.19-8.954h0L-4.2-8.9l0,.056.006.06.013.06.022.06.025.057.035.06.038.054.044.053.047.047.05.047.057.038.057.035.063.028.063.022.063.013.082.012.079.01.082.01.082.006.082,0h.085l.082,0,.085-.006.085-.013.085-.016.088-.019.085-.028.088-.035.091-.038.088-.05.091-.053-.126.774-.05.025-.05.025-.05.019-.047.019-.047.016-.05.016-.05.012-.054.01-.057.01-.063.006-.066.006-.072.006-.082,0h-.085l-.1,0h-.1l-.154,0L-3.725-7.5l-.157-.022-.157-.038-.154-.047-.148-.06-.142-.079-.132-.091-.123-.107-.107-.129-.091-.145-.076-.167-.054-.186L-5.1-8.781l-.01-.233.016-.258.013-.1.019-.117.025-.122L-5-9.743l.047-.135.056-.135.072-.138.088-.132.1-.126.123-.12.138-.107.157-.095.183-.078.2-.057L-3.6-10.9l.255-.012.123,0,.129.012.129.022.129.032.126.047.123.057.113.076.1.088.094.107.079.126.063.145.044.167.025.189,0,.214-.022.239-.047.265-.016.192H-4.445l.145-.62h1.378l.006-.079,0-.076-.006-.069-.013-.063L-2.96-9.9l-.022-.053L-3.013-10l-.031-.044-.038-.038-.041-.031-.047-.028-.047-.025-.05-.019-.05-.013-.053-.009-.057-.006-.06,0-.057.009-.053.013-.053.019-.054.025-.047.028-.047.035-.041.038L-3.882-10l-.038.047-.035.05-.028.054-.028.057-.022.063-.019.063-.013.066-.126.651",
    transform: "translate(5.109 10.917)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-22",
    "data-name": "group",
    transform: "translate(18.155 7.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-21",
    "data-name": "path",
    className: "cls-3",
    d: "M-14.636-4.979-14.677-5l-.041-.019-.044-.022-.047-.022-.047-.019L-14.91-5.1l-.053-.019-.057-.019-.06-.015-.06-.013-.066-.013-.066-.01-.072-.006-.072-.006h-.233l-.082.006-.085.01-.088.016-.088.025-.088.035-.088.044-.088.057-.085.069-.082.082-.079.1-.076.116-.069.138-.066.157-.06.176-.051.2-.019.113-.012.11-.006.11,0,.107.01.107.022.1.028.094.035.094.047.085.056.082.066.072.076.066.085.056.1.047.107.041.12.028.041.009.047.01.057.006.063.006.069.006h.151l.079-.006.082-.009.082-.016.079-.022.079-.025.079-.035.072-.041.066-.05L-15-2.877l-.142.84-.019.016L-15.181-2l-.025.022-.028.019-.035.025-.044.022-.05.022-.056.019-.072.022-.082.016-.094.013-.11.013L-15.9-1.8l-.142,0-.161,0-.176-.009-.145-.016-.145-.031-.145-.047-.145-.063-.138-.076-.132-.094-.126-.11-.117-.126-.1-.142-.088-.157-.075-.176-.057-.192-.038-.211-.013-.223.006-.245.035-.261.025-.129.028-.126.031-.123.031-.117.035-.11.041-.11.041-.1.044-.1.047-.1.047-.091.054-.088.057-.082.057-.079.063-.076.063-.069.066-.066L-17-5.612l.072-.06.076-.053.079-.05.085-.047.085-.041.088-.038.091-.035.1-.031.1-.025.1-.022.107-.019.107-.016.113-.013.113-.006.12,0,.1,0,.1.006.094.009.094.013.088.013.085.019.082.016.076.019.072.019.063.019.06.019.051.019.044.016.038.013.028.012.019.006Z",
    transform: "translate(17.846 6.071)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-23",
    "data-name": "group",
    transform: "translate(18.155 7.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-22",
    "data-name": "path",
    className: "cls-4",
    d: "M-14.636-4.979h0L-14.677-5l-.041-.019-.044-.022-.047-.022-.047-.019L-14.91-5.1l-.053-.019-.057-.019-.06-.015-.06-.013-.066-.013-.066-.01-.072-.006-.072-.006h-.233l-.082.006-.085.01-.088.016-.088.025-.088.035-.088.044-.088.057-.085.069-.082.082-.079.1-.076.116-.069.138-.066.157-.06.176-.051.2-.019.113-.012.11-.006.11,0,.107.01.107.022.1.028.094.035.094.047.085.056.082.066.072.076.066.085.056.1.047.107.041.12.028.041.009.047.01.057.006.063.006.069.006h.151l.079-.006.082-.009.082-.016.079-.022.079-.025.079-.035.072-.041.066-.05L-15-2.877l-.142.84-.019.016L-15.181-2l-.025.022-.028.019-.035.025-.044.022-.05.022-.056.019-.072.022-.082.016-.094.013-.11.013L-15.9-1.8l-.142,0-.161,0-.176-.009-.145-.016-.145-.031-.145-.047-.145-.063-.138-.076-.132-.094-.126-.11-.117-.126-.1-.142-.088-.157-.075-.176-.057-.192-.038-.211-.013-.223.006-.245.035-.261.025-.129.028-.126.031-.123.031-.117.035-.11.041-.11.041-.1.044-.1.047-.1.047-.091.054-.088.057-.082.057-.079.063-.076.063-.069.066-.066L-17-5.612l.072-.06.076-.053.079-.05.085-.047.085-.041.088-.038.091-.035.1-.031.1-.025.1-.022.107-.019.107-.016.113-.013.113-.006.12,0,.1,0,.1.006.094.009.094.013.088.013.085.019.082.016.076.019.072.019.063.019.06.019.051.019.044.016.038.013.028.012.019.006-.157.872",
    transform: "translate(17.846 6.071)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-24",
    "data-name": "group",
    transform: "translate(26.23 7.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-23",
    "data-name": "path",
    className: "cls-3",
    d: "M-13.144-18.768h-.872l.063-.349v-.031l-.05.063-.054.057-.053.05-.057.044-.057.041-.056.035-.057.028-.06.028-.06.022-.06.016-.06.016-.063.009-.063.01-.06.006-.063,0h-.063l-.164-.013-.151-.035-.138-.053-.126-.072-.113-.091-.1-.107-.088-.116-.076-.132-.063-.142-.05-.148-.035-.154-.025-.161-.01-.161,0-.163.016-.16.028-.161.047-.186.057-.176.066-.16.079-.151.082-.142.094-.126.1-.113.1-.1.11-.091.116-.079.12-.069.12-.054.126-.044.126-.028.126-.019.129-.006.091,0,.088.01.082.016.076.022.072.025.063.028.063.035.057.035.05.038.047.041.041.041.038.041.031.041.028.041.025.038.019.038.22-1.237h.856Z",
    transform: "translate(16.026 22.884)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-25",
    "data-name": "group",
    transform: "translate(26.23 7.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-24",
    "data-name": "path",
    className: "cls-4",
    d: "M-13.144-18.768h-.872l.063-.349v-.031l-.05.063-.054.057-.053.05-.057.044-.057.041-.056.035-.057.028-.06.028-.06.022-.06.016-.06.016-.063.009-.063.01-.06.006-.063,0h-.063l-.164-.013-.151-.035-.138-.053-.126-.072-.113-.091-.1-.107-.088-.116-.076-.132-.063-.142-.05-.148-.035-.154-.025-.161-.01-.161,0-.163.016-.16.028-.161.047-.186.057-.176.066-.16.079-.151.082-.142.094-.126.1-.113.1-.1.11-.091.116-.079.12-.069.12-.054.126-.044.126-.028.126-.019.129-.006.091,0,.088.01.082.016.076.022.072.025.063.028.063.035.057.035.05.038.047.041.041.041.038.041.031.041.028.041.025.038.019.038.22-1.237h.856l-.711,4.116",
    transform: "translate(16.026 22.884)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-26",
    "data-name": "group",
    transform: "translate(27.243 9.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-25",
    "data-name": "path",
    className: "cls-1",
    d: "M-2.023-8.437l.088-.006.082-.019.076-.022.072-.035.066-.038.063-.047.06-.053.053-.057.047-.063.044-.069.041-.073.035-.075.031-.079.025-.082.022-.085.016-.085.016-.088.009-.091v-.085l0-.088-.01-.082L-1.2-9.837l-.022-.076-.025-.072-.031-.063-.038-.06-.041-.05-.047-.044-.053-.038-.057-.025-.06-.016-.066-.006-.085.006-.079.013-.072.025-.072.031-.063.041-.063.051-.054.053-.053.06-.047.069-.044.072-.041.076-.035.082-.031.085-.025.085-.025.091-.019.091-.016.138.006.151.022.154.041.148.063.129.082.1.1.069Z",
    transform: "translate(2.467 10.287)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-27",
    "data-name": "group",
    transform: "translate(5.497 8.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-26",
    "data-name": "path",
    className: "cls-3",
    d: "M-13.072-12.369l-.126.7h-.793l.022-.129.016-.116L-13.94-12l.013-.047-.044.05-.05.05-.06.047-.066.044-.076.044-.079.038-.082.038-.085.031-.091.028-.091.022-.091.019-.094.013-.091.006-.091,0-.088-.01-.085-.013-.11-.028-.1-.031-.088-.041-.079-.047-.069-.05-.063-.057-.05-.06-.044-.063-.038-.066-.031-.069-.025-.069-.019-.069-.013-.072-.01-.072-.006-.069v-.069l.009-.123.019-.117.031-.11.041-.107.05-.1.057-.091.066-.088.076-.079.079-.072.088-.066.091-.06.094-.05.1-.044.1-.035.107-.028.11-.019h.006l.016,0,.022,0,.035,0,.038-.006.044,0,.047-.006.053-.006.054-.006.053-.006.057,0,.05-.006.05,0,.047,0,.044,0h.107l.076,0,.069,0h.069l.057,0,.044,0,.031,0h.009l.006-.022.019-.056.016-.066.006-.06-.013-.069-.028-.063-.038-.057-.05-.047-.06-.041-.066-.029-.076-.019-.082-.006-.088,0-.094,0h-.1l-.1,0-.1.006-.1.01-.1.009-.1.013-.094.013-.091.016-.082.016-.075.016-.069.019-.057.019-.044.022-.035.019.223-.758.069-.028.069-.025.076-.022.076-.016.076-.016.082-.013.082-.013.085-.006.088-.006.091,0,.094,0h.3l.11,0,.11,0,.088.006.094.016.1.022.1.028.1.038.094.044.094.053.088.06.079.069.069.076.063.085.047.094.031.1.019.107v.12l-.019.126Z",
    transform: "translate(15.938 15.081)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-28",
    "data-name": "group",
    transform: "translate(5.497 8.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-27",
    "data-name": "path",
    className: "cls-4",
    d: "M-13.072-12.369l-.126.7h-.793l.022-.129.016-.116L-13.94-12l.013-.047-.044.05-.05.05-.06.047-.066.044-.076.044-.079.038-.082.038-.085.031-.091.028-.091.022-.091.019-.094.013-.091.006-.091,0-.088-.01-.085-.013-.11-.028-.1-.031-.088-.041-.079-.047-.069-.05-.063-.057-.05-.06-.044-.063-.038-.066-.031-.069-.025-.069-.019-.069-.013-.072-.01-.072-.006-.069v-.069l.009-.123.019-.117.031-.11.041-.107.05-.1.057-.091.066-.088.076-.079.079-.072.088-.066.091-.06.094-.05.1-.044.1-.035.107-.028.11-.019h.006l.016,0,.022,0,.035,0,.038-.006.044,0,.047-.006.053-.006.054-.006.053-.006.057,0,.05-.006.05,0,.047,0,.044,0h.107l.076,0,.069,0h.069l.057,0,.044,0,.031,0h.009l.006-.022.019-.056.016-.066.006-.06-.013-.069-.028-.063-.038-.057-.05-.047-.06-.041-.066-.029-.076-.019-.082-.006-.088,0-.094,0h-.1l-.1,0-.1.006-.1.01-.1.009-.1.013-.094.013-.091.016-.082.016-.075.016-.069.019-.057.019-.044.022-.035.019.223-.758.069-.028.069-.025.076-.022.076-.016.076-.016.082-.013.082-.013.085-.006.088-.006.091,0,.094,0h.3l.11,0,.11,0,.088.006.094.016.1.022.1.028.1.038.094.044.094.053.088.06.079.069.069.076.063.085.047.094.031.1.019.107v.12l-.019.126-.318,1.661",
    transform: "translate(15.938 15.081)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-29",
    "data-name": "group",
    transform: "translate(6.475 10.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-28",
    "data-name": "path",
    className: "cls-2",
    d: "M-5.151-.258l0-.016-.013-.016L-5.186-.3-5.217-.3l-.035-.006-.041,0h-.094l-.05,0L-5.491-.3l-.05.006-.05.006-.047.006-.044.01-.038.009-.035.01-.022.006-.025.01-.035.012-.035.016-.041.019-.041.022L-6-.15l-.041.025-.044.032-.041.031-.038.038L-6.2.013l-.031.041L-6.25.1l-.019.05L-6.278.2l0,.107.016.085.031.063L-6.193.5l.047.031.053.019.05.01.05,0,.094,0,.085-.01L-5.73.539-5.658.52-5.6.5l.06-.028.053-.028.047-.035.041-.031.038-.038L-5.324.3-5.3.265l.022-.038.019-.038.016-.035L-5.233.12l.025-.091.022-.1.019-.1Z",
    transform: "translate(6.281 0.314)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-30",
    "data-name": "group",
    transform: "translate(0.887 7.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-29",
    "data-name": "path",
    className: "cls-3",
    d: "M-3.9-18.84h-.856l.714-4.132h1.488l.142,2.451,1.029-2.451H.169l-.73,4.132h-.856l.541-3.087H-.911L-2.191-18.84h-.966l-.006-.129-.022-.343-.028-.488-.031-.56-.031-.563-.028-.494-.022-.359-.006-.151h-.047Z",
    transform: "translate(4.759 22.972)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-31",
    "data-name": "group",
    transform: "translate(0.887 7.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-30",
    "data-name": "path",
    className: "cls-4",
    d: "M-3.9-18.84h-.856l.714-4.132h1.488l.142,2.451,1.029-2.451H.169l-.73,4.132h-.856l.541-3.087H-.911L-2.191-18.84h-.966l-.006-.129-.022-.343-.028-.488-.031-.56-.031-.563-.028-.494-.022-.359-.006-.151h-.047L-3.9-18.84",
    transform: "translate(4.759 22.972)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-32",
    "data-name": "group",
    transform: "translate(21.129 8.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-31",
    "data-name": "path",
    className: "cls-3",
    d: "M-13-12.369l-.129.7h-.79l.006-.129,0-.113V-12l.006-.038-.041.047-.047.047-.057.044-.063.044-.066.041-.076.038-.079.038-.079.031-.085.025-.088.025-.088.016-.088.013-.091.006-.088,0-.085-.01-.085-.013-.113-.028-.1-.031-.088-.041-.082-.047-.069-.05-.06-.057-.05-.06-.044-.063-.038-.066-.028-.069-.025-.069-.016-.069-.013-.072-.009-.072-.006-.069v-.069l.006-.123.019-.117.028-.11.041-.107.047-.1.06-.091.066-.088.072-.079.082-.072.085-.066.091-.06.1-.05.1-.044.1-.035.1-.028.107-.019h.006l.016,0,.022,0,.031,0,.041-.006.044,0,.047-.006.05-.006.054-.006.056-.006.054,0,.053-.006.05,0,.044,0,.044,0h.11l.075,0,.072,0h.069l.06,0,.05,0,.028,0h.012l.006-.022.01-.056.01-.066.006-.06-.013-.069-.025-.063L-13.7-14.2l-.047-.047-.057-.041-.066-.029-.069-.019-.076-.006-.088,0-.094,0h-.1l-.1,0-.1.006-.1.01-.1.009-.1.013-.094.013-.091.016-.082.016-.075.016-.069.019-.057.019-.044.022-.035.019.22-.758.069-.028.072-.025.072-.022.076-.016.079-.016.079-.013.082-.013.085-.006.088-.006.091,0,.091,0h.3l.107,0,.107,0,.088.006.094.016.1.022.1.028.1.038.1.044.094.053.088.06.079.069.072.076.063.085.047.094.035.1.022.107v.12l-.016.126Z",
    transform: "translate(15.851 15.081)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-33",
    "data-name": "group",
    transform: "translate(23.832 10.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-32",
    "data-name": "path",
    className: "cls-3",
    d: "M0-3.185.019-3.2v.044l.019-.019.129-.7L.129-3.884Zm.038.006M.019-3.16l.016,0,0-.016Zm0,0",
    transform: "translate(0 3.884)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-34",
    "data-name": "group",
    transform: "translate(23.039 11.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-33",
    "data-name": "path",
    className: "cls-3",
    d: "M-.1,0l.019.022H-.119l0,.022H.69V0Z",
    transform: "translate(0.122)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-35",
    "data-name": "group",
    transform: "translate(23.042 11.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-34",
    "data-name": "path",
    className: "cls-3",
    d: "M-.1-.01l.029.023L-.1-.012Zm0,0h0l0,0ZM-.11.038l0,.085V.237L-.12.366h.038L-.076.237-.069.123l0-.085V.013L-.1-.01Z",
    transform: "translate(0.12 0.012)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-36",
    "data-name": "group",
    transform: "translate(21.868 11.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-35",
    "data-name": "path",
    className: "cls-3",
    d: "M0-1.951H0l.088.013.085.01.088,0,.091-.006.091-.013.088-.016L.62-1.992l.088-.025.079-.031.082-.038.076-.038.066-.044.066-.044.057-.044.051-.05.041-.047-.031-.025-.041.047-.044.044-.057.044L.991-2.2l-.066.038L.85-2.124l-.076.038L.7-2.055.614-2.03.526-2l-.088.016-.085.013L.261-1.97l-.088,0L.088-1.976.006-1.989Z",
    transform: "translate(0 2.379)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-37",
    "data-name": "group",
    transform: "translate(21.107 10.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-36",
    "data-name": "path",
    className: "cls-3",
    d: "M0,0H0L0,.069.009.138l.01.075L.031.286.047.356.072.428.1.5.142.566.186.632l.05.06L.3.752.371.8l.082.05L.544.894l.1.031L.761.953.768.916.654.887.557.856.472.815.39.771.324.72.267.667.217.607.173.547.138.481.11.415.085.349.069.28.057.208.047.138.041.069.044,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-38",
    "data-name": "group",
    transform: "translate(21.107 9.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-37",
    "data-name": "path",
    className: "cls-3",
    d: "M-5.151,0h0l-.11.019-.107.028-.1.035-.1.044-.1.05-.094.063L-5.85.305l-.082.076L-6.007.46l-.066.088-.063.094-.047.1-.041.107-.028.113-.019.12-.009.123h.044l0-.123.019-.113.028-.107.041-.107.047-.1.057-.088.066-.088.069-.079.082-.069L-5.74.271l.088-.057.1-.05L-5.46.12l.1-.035.1-.029.1-.019Z",
    transform: "translate(6.281)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-39",
    "data-name": "group",
    transform: "translate(22.237 9.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-38",
    "data-name": "path",
    className: "cls-3",
    d: "M-2.8,0l-.044.006-.044,0-.05,0-.053.006-.053,0L-3.1.028l-.053.006L-3.2.041l-.047.006-.044,0-.041.006-.031,0-.025,0-.012,0h-.006V.1H-3.4l.019,0,.019,0,.031,0,.041-.006.044,0L-3.2.079l.05-.006L-3.1.066-3.043.06l.053,0L-2.936.05l.05,0,.044,0h.079V0Z",
    transform: "translate(3.411)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-40",
    "data-name": "group",
    transform: "translate(22.885 9.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-39",
    "data-name": "path",
    className: "cls-3",
    d: "M0,0V.044H.151L.223.05H.352l.05,0,.028,0H.444l.016,0,0-.019L.425.035.444.019H.431L.4.015l-.05,0L.292.006H.151L.075,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-41",
    "data-name": "group",
    transform: "translate(23.31 9.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-40",
    "data-name": "path",
    className: "cls-3",
    d: "M-.315,0H-.356l0,.06L-.368.123-.378.179-.384.2l.038.006L-.34.186l.01-.056L-.321.06-.312,0Z",
    transform: "translate(0.384)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-42",
    "data-name": "group",
    transform: "translate(22.967 8.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-41",
    "data-name": "path",
    className: "cls-3",
    d: "M0-.186v0l.072,0,.066.019L.2-.133l.053.038L.3-.051.337,0,.362.059.374.125H.412L.4.053.374-.016.33-.076.28-.126.22-.17.151-.2.079-.217,0-.227v.041Z",
    transform: "translate(0 0.227)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-43",
    "data-name": "group",
    transform: "translate(21.617 8.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-42",
    "data-name": "path",
    className: "cls-3",
    d: "M0-.9l.031.019L.063-.9.1-.924.157-.942.226-.961.3-.977.384-.993l.091-.016.091-.012.1-.013.1-.01.1-.009.1-.006h.293l.088,0v-.038l-.088,0L1.167-1.1h-.1l-.1.006-.1.006-.1.009-.1.009-.1.013-.1.012-.091.016L.3-1.015.22-1,.151-.98l-.06.019L.044-.939.006-.917.038-.9Z",
    transform: "translate(0 1.103)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-44",
    "data-name": "group",
    transform: "translate(21.617 8.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-43",
    "data-name": "path",
    className: "cls-3",
    d: "M-1.061,0l-.013.016-.22.758.038.006.22-.758-.013.016L-1.061,0l-.01,0,0,.013Z",
    transform: "translate(1.294)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-45",
    "data-name": "group",
    transform: "translate(21.849 8.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-44",
    "data-name": "path",
    className: "cls-3",
    d: "M-6.386-.043h0l-.107-.006-.107,0h-.3l-.091.006-.091,0-.088.006-.085.006-.085.013L-7.415,0l-.079.016-.076.016-.076.022-.072.025L-7.786.1l.013.038L-7.7.111l.072-.025.069-.022.075-.016.079-.016L-7.33.02l.079-.013L-7.166,0-7.078,0l.091,0H-6.6l.107,0h.107Z",
    transform: "translate(7.786 0.052)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-46",
    "data-name": "group",
    transform: "translate(23.25 8.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-45",
    "data-name": "path",
    className: "cls-3",
    d: "M-4.922-4.865h0l.016-.129v-.12l-.022-.11-.035-.1-.05-.1-.063-.088-.076-.079-.079-.069-.091-.06-.094-.057-.1-.044-.1-.038-.1-.028-.1-.022-.1-.016L-6-5.932v.038l.088.006.091.016.1.022.1.028.1.038.094.044.094.05.085.06.079.069.069.072.063.082L-5-5.315l.035.1.022.1v.12l-.016.123Z",
    transform: "translate(6.001 5.932)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-47",
    "data-name": "group",
    transform: "translate(23.961 9.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-46",
    "data-name": "path",
    className: "cls-3",
    d: "M-.172-7.6h0l.33-1.661L.12-9.272-.21-7.611Z",
    transform: "translate(0.21 9.272)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-48",
    "data-name": "group",
    transform: "translate(22.108 10.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-47",
    "data-name": "path",
    className: "cls-1",
    d: "M-5.065-.272l-.006-.019-.013-.016-.022-.01-.031-.009-.035,0-.041,0H-5.26l-.047,0-.05.006-.05.006-.05.006L-5.506-.3l-.047.01-.041.006-.041.009-.031.006-.022,0-.025.009-.031.009-.035.013-.041.019L-5.858-.2-5.9-.178l-.041.028-.041.028-.041.035-.035.035-.035.041-.028.044L-6.145.08l-.019.05-.01.054,0,.107.016.085.025.063L-6.1.486l.047.031L-6,.536l.054.01.053,0,.094,0,.088-.01.082-.016L-5.553.5l.069-.025.06-.028.057-.031.05-.038.044-.035L-5.235.3-5.2.263l.028-.041L-5.15.184l.016-.038.013-.038.009-.035L-5.1-.014l.016-.091.013-.088Z",
    transform: "translate(6.176 0.332)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-49",
    "data-name": "group",
    transform: "translate(29.7 10.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-48",
    "data-name": "path",
    className: "cls-3",
    d: "M0-1.937l.006-.072.025-.085L.076-2.17l.053-.066L.195-2.29.27-2.327l.082-.025L.44-2.362l.088.009.082.025.076.038.066.054.054.066.044.076.025.085.006.072H.787l0-.056L.765-2.063.733-2.126.692-2.179l-.05-.044-.06-.031L.513-2.277.44-2.283l-.072.006L.3-2.255l-.06.031-.05.044-.041.053-.031.063L.1-1.994l-.006.056Z",
    transform: "translate(0 2.362)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-50",
    "data-name": "group",
    transform: "translate(29.983 11.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-49",
    "data-name": "path",
    className: "cls-3",
    d: "M0-.861V-1.05H.173l.038,0,.035.006.025.01.022.012L.308-1l.013.019.006.022,0,.022,0,.028L.321-.886.311-.867.305-.861H.173l.013,0,.022,0L.226-.874.242-.88l.013-.01L.261-.9.267-.915V-.937l0-.016L.258-.965.249-.971.239-.978l-.016,0-.016,0H.079v.123Z",
    transform: "translate(0 1.05)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-51",
    "data-name": "group",
    transform: "translate(29.697 11.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-50",
    "data-name": "path",
    className: "cls-3",
    d: "M-.015,0l0,.019.01.091L.017.2.061.271.114.333.18.387.256.428.338.453.426.462.514.453.6.428.671.387.737.333.791.271.835.2.86.11.869.019.866,0H.772l0,.019L.769.094.75.163.718.223.677.277.627.321.567.356.5.378.426.384.353.378.284.356.224.321.174.277.133.223.1.163.083.094.076.019V0Z",
    transform: "translate(0.018)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-52",
    "data-name": "group",
    transform: "translate(29.983 11.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-51",
    "data-name": "path",
    className: "cls-3",
    d: "M0,0V.192H.079V.035H.157L.252.192H.315L.22.035H.242L.264.028.283.022.3.01.305,0H.173L.157,0H.079V0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-53",
    "data-name": "group",
    transform: "translate(29.697 10.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-52",
    "data-name": "path",
    className: "cls-4",
    d: "M0-2.023H0l.009-.091L.035-2.2l.044-.076.054-.066L.2-2.395l.076-.038.082-.025.088-.01.088.01.082.025.076.038.066.053.054.066L.853-2.2l.025.085.01.091-.01.091-.025.085-.044.076-.054.063-.066.053-.076.041-.082.025L.444-1.58.356-1.589.274-1.614.2-1.655.132-1.709.079-1.772.035-1.847.009-1.932,0-2.023",
    transform: "translate(0 2.467)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-54",
    "data-name": "group",
    transform: "translate(29.984 11.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-53",
    "data-name": "path",
    className: "cls-4",
    d: "M-.358-1.736H-.437v-.381h.173l.038,0,.035.006.025.009.022.013.016.019.013.019.006.022,0,.022,0,.028-.006.022-.01.019-.012.016-.016.013L-.173-1.9l-.022.006H-.217l.094.157H-.185L-.28-1.894H-.358v.157",
    transform: "translate(0.437 2.117)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-55",
    "data-name": "group",
    transform: "translate(30.062 11.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-54",
    "data-name": "path",
    className: "cls-4",
    d: "M-.358-.574h0L-.33-.58l.022,0L-.289-.59-.274-.6l.013-.01.006-.01.006-.016V-.653l0-.016L-.258-.681l-.01-.006L-.277-.694l-.016,0-.016,0H-.437v.126h.079",
    transform: "translate(0.437 0.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-56",
    "data-name": "group",
    transform: "translate(29.791 10.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-55",
    "data-name": "path",
    className: "cls-4",
    d: "M-1.593-3.33h0l.072-.006.069-.022.06-.035.05-.044L-1.3-3.49l.031-.06.019-.069.006-.076L-1.25-3.77l-.019-.069L-1.3-3.9l-.041-.053L-1.391-4l-.06-.031-.069-.022-.072-.006-.072.006-.069.022L-1.794-4l-.05.044-.041.053-.031.063-.019.069-.006.075.006.076.019.069.031.06.041.053.05.044.06.035.069.022.072.006",
    transform: "translate(1.942 4.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-57",
    "data-name": "group",
    transform: "translate(24.216 8.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-56",
    "data-name": "path",
    className: "cls-3",
    d: "M0-15.525H.887l.318-1.79.013-.069.019-.069.019-.069.025-.069.031-.069.038-.066.041-.063.05-.06L1.5-17.9l.063-.05L1.633-18l.082-.038.091-.031.1-.025.11-.019.123-.006h.079l.142-.809-.088.006-.085.01-.079.016-.076.022-.069.025L1.9-18.82l-.063.035-.06.038-.057.044-.054.044-.05.05-.05.051-.047.053-.047.06-.047.056-.044.063.094-.57H.588Z",
    transform: "translate(0 18.93)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-58",
    "data-name": "group",
    transform: "translate(24.216 8.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-57",
    "data-name": "path",
    className: "cls-4",
    d: "M0-15.525H.887l.318-1.79.013-.069.019-.069.019-.069.025-.069.031-.069.038-.066.041-.063.05-.06L1.5-17.9l.063-.05L1.633-18l.082-.038.091-.031.1-.025.11-.019.123-.006h.079l.142-.809-.088.006-.085.01-.079.016-.076.022-.069.025L1.9-18.82l-.063.035-.06.038-.057.044-.054.044-.05.05-.05.051-.047.053-.047.06-.047.056-.044.063.094-.57H.588L0-15.525",
    transform: "translate(0 18.93)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-59",
    "data-name": "group",
    transform: "translate(15.884 8.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-58",
    "data-name": "path",
    className: "cls-3",
    d: "M0-15.525H.9l.3-1.79.013-.069.016-.066.016-.066.022-.063.025-.063.031-.06.038-.057.044-.053.05-.047.057-.047.069-.038.076-.035.088-.028.1-.025.107-.016.123-.01h.01l.013,0,.016,0H2.13l.016,0,.013,0,.01,0h0l0-.013.009-.038L2.2-18.15l.016-.069.022-.082.022-.088.028-.088.028-.088.025-.06.031-.06.031-.06.031-.054.028-.047.022-.038L2.5-18.9l.006-.01h0l-.013,0-.016,0-.022,0H2.429l-.025,0-.022,0H2.36l-.1.006-.088.01-.082.016-.076.019-.072.025-.066.031-.06.031-.057.038-.054.041-.05.047-.047.047-.047.054-.047.053-.044.06-.047.063-.047.063.113-.57h-.9Z",
    transform: "translate(0 18.93)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-60",
    "data-name": "group",
    transform: "translate(15.884 8.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-59",
    "data-name": "path",
    className: "cls-4",
    d: "M0-15.525H.9l.3-1.79.013-.069.016-.066.016-.066.022-.063.025-.063.031-.06.038-.057.044-.053.05-.047.057-.047.069-.038.076-.035.088-.028.1-.025.107-.016.123-.01h.01l.013,0,.016,0H2.13l.016,0,.013,0,.01,0h0l0-.013.009-.038L2.2-18.15l.016-.069.022-.082.022-.088.028-.088.028-.088.025-.06.031-.06.031-.06.031-.054.028-.047.022-.038L2.5-18.9l.006-.01h0l-.013,0-.016,0-.022,0H2.429l-.025,0-.022,0H2.36l-.1.006-.088.01-.082.016-.076.019-.072.025-.066.031-.06.031-.057.038-.054.041-.05.047-.047.047-.047.054-.047.053-.044.06-.047.063-.047.063.113-.57h-.9L0-15.525",
    transform: "translate(0 18.93)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-61",
    "data-name": "group",
    transform: "translate(29.706 14.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-60",
    "data-name": "path",
    className: "cls-1",
    d: "M0-1.592V-1.6l.025-.082.044-.072.054-.063.066-.051L.264-1.91l.082-.022.088-.009.088.009L.6-1.91l.076.038.066.051L.8-1.759l.044.072L.868-1.6v.012H.777L.758-1.658l-.031-.06L.686-1.771l-.05-.044L.576-1.85.507-1.872.434-1.878l-.072.006L.293-1.85l-.06.035-.05.044-.041.054-.032.06-.019.066Z",
    transform: "translate(0 1.941)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-62",
    "data-name": "group",
    transform: "translate(29.983 14.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-61",
    "data-name": "path",
    className: "cls-1",
    d: "M-.789,0H-.962V.11h.079V.047h.129l.016,0,.016,0L-.713.06-.7.066-.7.079l0,.016V.11h.063l0-.028L-.641.06-.654.041-.669.025-.691.013-.717.006-.751,0Z",
    transform: "translate(0.962)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-63",
    "data-name": "group",
    transform: "translate(29.697 14.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-62",
    "data-name": "path",
    className: "cls-1",
    d: "M-.043,0-.052.069H.042L.049,0V0Z",
    transform: "translate(0.052)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-64",
    "data-name": "group",
    transform: "translate(29.983 14.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-63",
    "data-name": "path",
    className: "cls-1",
    d: "M-1.22,0V.006l-.006.016-.006.009-.013.01L-1.26.047l-.019.006-.022,0L-1.33.063h-.079V0h-.079V.069h.3l.013-.013.009-.015L-1.16.022l0-.022Z",
    transform: "translate(1.487)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-65",
    "data-name": "group",
    transform: "translate(30.484 14.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-64",
    "data-name": "path",
    className: "cls-1",
    d: "M0,0V0L.006.069H.1L.091,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-66",
    "data-name": "group",
    transform: "translate(29.697 15.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-65",
    "data-name": "path",
    className: "cls-1",
    d: "M0,0V.009L.009.1.035.186.079.261.132.327.2.381.274.419.356.444.444.453.532.444.614.419.689.381.755.327.809.261.853.186.878.1.887.009V0H.793V.009L.787.085.768.154.736.214.7.267.645.311.585.346.516.368.444.374.371.368.3.346.242.311.192.267.151.214.12.154.1.085.094.009V0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-67",
    "data-name": "group",
    transform: "translate(29.983 15.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-66",
    "data-name": "path",
    className: "cls-1",
    d: "M0,0V.183H.079V.025H.157L.252.183H.315L.22.025H.242L.264.019.283.012.3,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaster);
export default __webpack_public_path__ + "static/media/icon-master.b6d2f87a5fe9972ba87ab87d6e7648c2.svg";
export { ForwardRef as ReactComponent };